var __vue_script__, __vue_template__
var __vue_styles__ = {}
require("!!vue-style-loader!css-loader!../../node_modules/vue-loader/lib/style-rewriter.js?id=_v-0a95ad80&scoped=true!sass-loader!../../node_modules/vue-loader/lib/selector.js?type=style&index=0!../../node_modules/eslint-loader/index.js!./NowPlayingSectionLayout.vue")
__vue_script__ = require("!!babel-loader?presets[]=es2015&plugins[]=transform-runtime&comments=false!../../node_modules/vue-loader/lib/selector.js?type=script&index=0!../../node_modules/eslint-loader/index.js!./NowPlayingSectionLayout.vue")
__vue_template__ = require("!!vue-html-loader!../../node_modules/vue-loader/lib/template-rewriter.js?id=_v-0a95ad80!../../node_modules/vue-loader/lib/selector.js?type=template&index=0!../../node_modules/eslint-loader/index.js!./NowPlayingSectionLayout.vue")
module.exports = __vue_script__ || {}
if (module.exports.__esModule) module.exports = module.exports.default
var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
if (__vue_template__) {
__vue_options__.template = __vue_template__
}
if (!__vue_options__.computed) __vue_options__.computed = {}
Object.keys(__vue_styles__).forEach(function (key) {
var module = __vue_styles__[key]
__vue_options__.computed[key] = function () { return module }
})



//////////////////
// WEBPACK FOOTER
// ./src/v2-components/NowPlayingSectionLayout.vue
// module id = 350
// module chunks = 0